import { render, staticRenderFns } from "./ResearcherQutes.vue?vue&type=template&id=469ccbb5&scoped=true"
import script from "./ResearcherQutes.vue?vue&type=script&lang=js"
export * from "./ResearcherQutes.vue?vue&type=script&lang=js"
import style0 from "./ResearcherQutes.vue?vue&type=style&index=0&id=469ccbb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ccbb5",
  null
  
)

export default component.exports